import React, { useCallback } from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';
import Picture from '../../../../components/ui/Picture/Picture';
import { ArrowRight, Plus } from '../../../../components/ui/Icons';

export default function Hit({
  hit,
}: componentTypes.HitProps) {
  const {
    uri,
    title,
    image,
    shortDescription,
    blogType,
    postDate,
    variantCount,
  } = hit;

  const formatDate = useCallback((date: string, format?: Intl.DateTimeFormatOptions, locales: Intl. LocalesArgument = 'nl') => (
    `${new Intl.DateTimeFormat(locales, format).format(new Date(date))}`
  ), []);

  const dateTimeString = useCallback(() => {
    const date = new Date(postDate);
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  }, [postDate]);

  return (
    <div className="flex w-full md:w-1/2 lg:w-1/3 px-4 lg:px-4.5">
      <a
        href={Craft.getSiteUrl(uri)}
        className="group/card w-full flex flex-col no-underline bg-white text-near-black text-base rounded-lg hover:shadow-sm overflow-hidden"
      >
        <div className="relative aspect-3/2">
          {image && (
            <Picture
              image={image}
              classes="w-full h-full object-cover absolute top-0 left-0"
              loading="lazy"
            />
          )}
        </div>
        <div className="px-4 lg:px-6 pt-4 lg:pt-6 last:pb-4 last:lg:pb-6 flex-1.0">
          <div className="two-row mb-4 last:mb-0">
            <h3>{title}</h3>
            {/* eslint-disable-next-line react/no-danger */}
            <div className="three-row" dangerouslySetInnerHTML={{ __html: shortDescription }} />
          </div>
        </div>
        <div className="flex justify-between items-center gap-x-4 px-4 lg:px-6 pt-4 lg:pt-6 pb-3">
          <ul className="flex flex-wrap items-center text-sm font-light py-1.7">
            {blogType && blogType[0] && blogType[0].title && (
              <li className="after:content-['|'] after:mx-2.5 after:text-light-grey-2 last:after:hidden">
                <span className="font-semibold">{blogType[0].title}</span>
              </li>
            )}
            <li className="after:content-['|'] after:mx-2.5 after:text-light-grey-2 last:after:hidden">
              <div className="flex items-center gap-x-3">
                <time dateTime={dateTimeString()}>
                  {formatDate(postDate, {
                    day: '2-digit',
                    month: 'long',
                    year: 'numeric',
                  })}
                </time>
                {variantCount && (
                  <div className="flex items-center gap-1">
                    <Plus className="w-3.5 inline-lock" />
                    <span className="font-normal">{variantCount}</span>
                  </div>
                )}
              </div>
            </li>
          </ul>
          <span className="inline-flex transition-transform w-4.7 mr-2 text-dark-shade group-hover/card:translate-x-0.5">
            <ArrowRight className="w-full" />
          </span>
        </div>
      </a>
    </div>
  );
}
